import { Component, OnInit, ViewChild } from '@angular/core';
import { isBs3 } from 'ngx-bootstrap/utils';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ModalDirective } from 'ngx-bootstrap/modal';
// import { Module } from 'ag-grid-community';
import { Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { ConstantService } from '../../../services/constant.service';
import { Router } from '@angular/router';
import { ViewRendererComponent } from '../../../renderer/view-renderer.component';
import { ApiService } from '../../../services/api.service';
import { GrievanceService } from '../../../services/grievance.services';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import { ExcelService } from '../../../services/export-excel.service';
import { ImageRendererComponent } from '../../../renderer/image-renderer.component';

@Component({
  selector: 'app-user-monthly-attendance',
  templateUrl: './user-monthly-attendance.component.html'
})
export class UserMonthlyAttendanceComponent implements OnInit {
  @ViewChild('deleteComplainModal') public deleteComplainModal: ModalDirective;
  @ViewChild('deleteBulkComplainModal') public deleteBulkComplainModal: ModalDirective;
  @ViewChild('updateComplaintModal') public updateComplaintModal: ModalDirective;
  @ViewChild('attachmentModal') public attachmentModal: ModalDirective;
  isBs3 = isBs3();
  public gridApi;
  public gridColumnApi;
  public gridOptions;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  public permission;
  public rowClassRules;
  public rowSelection;
  _ = _;
  moment = moment;
  selectedYear = moment().format('YYYY');
  selectedMonth = moment().format('MM');

  dropdownList = [];
  selectedUser: any = {};
  dropdownSettings: IDropdownSettings = {};
  filterParams = {
    project: '',
    username: '',
    month: moment().format('MM'),
    year: moment().format('YYYY'),
    attendance: 'all'
  }

  bsRangeValue: Date[];
  paginaton = {
    totalItems: 0,
    currentPage: 1,
    maxSize: 100,
  }

  years = [moment().format('YYYY'), moment().subtract(1, 'years').format('YYYY')];
  months = this.constantService.MONTHS;

  alert = {
    type: 'info',
    msg: '',
    timeout: 3000
  }
  maxDate = new Date();

  exportAsConfig: ExportAsConfig = {
  type: 'pdf', // the type you want to download
  elementIdOrContent: 'tableToPrint', // the id of html/table element,
  options: { // html-docx-js document options

    jsPDF: {
       orientation: 'landscape',
    },
    margins: {
     top: '40px',
     bottom: '40px',
     left: '40px',
     right: '40px'
   }

  }
}

username = '';
  selectedComplaint : any = {};

  exportingCsv = false;
  constructor(private constantService: ConstantService, private apiService: ApiService, private grievanceService: GrievanceService,
    public router: Router, private exportAsService: ExportAsService, private excelService: ExcelService) {
    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split('');
    this.username = this.constantService.getCookies().USERNAME;

    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      filterParams: { buttons: ['clear'] }
    };

    this.frameworkComponents = {
      viewRenderer: ViewRendererComponent,
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer : DeleteButtonRendererComponent,
      imageButtonRenderer : ImageRendererComponent,
    };

    this.rowSelection = 'multiple';

    this.columnDefs = [
      { headerName: 'Date', field: 'date', width: 120 },
      { headerName: 'Project', field: 'project_name', width: 150 },
      { headerName: 'Employee Id', field: 'employee_id', width: 100 },
      { headerName: 'User Id', field: 'username', width: 150 },
      { headerName: 'User Name', field: 'fullName', width: 150 },
      { headerName: 'Location', field: 'location', width: 150 },
      {
        headerName: 'In Detail',
        children: [
            { headerName: 'In Time', field: 'in_time', width: 120, columnGroupShow: 'closed' },
            { headerName: 'Address', field: 'in_location', width: 150, columnGroupShow: 'closed' },
            { headerName: 'Latitude', field: 'in_latitude', flex: 1, columnGroupShow: 'open' },
            { headerName: 'Longitude', field: 'in_longitude', flex: 1 , columnGroupShow: 'open'},
            { headerName: 'Attachment', field: 'value',
               cellRenderer: params =>
              { return params.data.in_attachment ? '<img src="' + params.data.in_attachment + '" width="100px" height="100px">': ''},
              colId: 'in_attachment',  width: 150 ,filter: false, resizable: true, sortable: false,cellClass: ['text-center'], columnGroupShow: 'closed'  },

        ]
        },
        {
          headerName: 'Out Detail',
          children: [
              { headerName: 'Out Time', field: 'out_time', width: 120, columnGroupShow: 'closed' },
              { headerName: 'Address', field: 'out_location', width: 150, columnGroupShow: 'closed' },
              { headerName: 'Latitude', field: 'out_latitude', flex: 1, columnGroupShow: 'open' },
              { headerName: 'Longitude', field: 'out_longitude', flex: 1 , columnGroupShow: 'open'},
              { headerName: 'Attachment', field: 'value',
              cellRenderer: params =>
             { return params.data.out_attachment ? '<img src="' + params.data.out_attachment + '" width="100px" height="100px">': ''},
             colId: 'out_attachment', width: 150 , filter: false, resizable: true, sortable: false,cellClass: ['text-center'], columnGroupShow: 'closed'  },

          ]
      },
      { headerName: 'Status', field: 'status', width: 100, filter: false, pinned: 'right', cellRenderer: params => {
        return `<div class="${params.data.status}" >${params.data.status}</div>`;
      }},
    ]

  }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.getResources();
  }
  records = [];
  paginatedRecord = [];
  attendanceList = [];

  searchReport() {
    if(this.filterParams.username) {
      this.getMonthDays();
      this.records = [];

      this.attendanceList = [];
      this.paginatedRecord = [];
      let queryString = "attendance.*, project.name as project_name FROM attendance, project WHERE MONTH(attendance.date) = '" + this.filterParams.month + "' AND YEAR(attendance.date) = '" + this.filterParams.year + "'";
      if(this.filterParams.username) queryString += " AND attendance.username LIKE '" + this.filterParams.username + "'";
      if(this.filterParams.project) queryString += " AND attendance.project LIKE '" + this.filterParams.project + "'";
      queryString += " AND attendance.project = project.srl_no ORDER BY srl_no DESC";
      console.log(queryString);
      this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
        this.records = resp;
        this.paginaton.totalItems = this.records.length
        this.pageChanged({ page: 1, itemsPerPage: 100 });
        this.arrangeDataForExport(this.records);

        let records = {};
        _.each(this.records, (i) => {
          records[moment(i.date).format('YYYY-MM-DD')] = i;
        })
        let dateArray = this.generateMonthDate();
        console.log(this.userObj);
        let username = this.filterParams.username;
        _.each(dateArray, (date) => {
          let userAttendance = {
            employee_id: this.userObj[this.filterParams.username].employee_id,
            fullName: this.userObj[this.filterParams.username].full_name,
            username: this.userObj[this.filterParams.username].phone_no,
            location: this.userObj[this.filterParams.username].work_location,
            project_name: this.projectObject[this.userObj[username].project] ? this.projectObject[this.userObj[username].project].name : '',
            date: date,
            in_time: records[date] ? moment(records[date].in_time).format('HH:mm:ss') : '',
            in_latitude: records[date] ? records[date].in_latitude : '',
            in_longitude: records[date] ? records[date].in_longitude : '',
            in_location: records[date] ? records[date].in_address : '',
            in_attachment: records[date] ? records[date].in_attachment : '',
            out_time: records[date] ? moment(records[date].out_time).format('HH:mm:ss') : '',
            out_latitude: records[date] ? records[date].out_latitude : '',
            out_longitude: records[date] ? records[date].out_longitude : '',
            out_location: records[date] ? records[date].out_address : '',
            out_attachment: records[date] ? records[date].out_attachment : '',
            status: records[date] ? 'present' : 'absent'
          }

          if(this.filterParams.attendance === 'all') {
            console.log(date)
            this.attendanceList.push(userAttendance);
          } else if(this.filterParams.attendance === 'absent') {
            if(!records[date]) this.attendanceList.push(userAttendance);
          }  else if(this.filterParams.attendance === 'present') {
            if(records[date]) this.attendanceList.push(userAttendance);
          }

        });
        this.paginatedRecord = this.attendanceList;
        this.arrangeDataForExport(this.paginatedRecord);

      })
    }
  }


  generateMonthDate() {
    let dates = [];
    if(this.filterParams.month === moment().format('MM')){
      let dt = parseInt(moment().format('DD'));
      var array = _.range(1, dt+1);
      _.each(array, (d) => {
        let dt = `${d}`.padStart(2, "0");
        dates.push(`${this.filterParams.year}-${this.filterParams.month}-${dt}`);
      })
    } else {
      let daysInMonth = moment(`${this.filterParams.year}-${this.filterParams.month}`, "YYYY-MM").daysInMonth();
      var array = _.range(1, daysInMonth+1);
      _.each(array, (d) => {
        let dt = `${d}`.padStart(2, "0");

        dates.push(`${this.filterParams.year}-${this.filterParams.month}-${dt}`);
      })
    }
    return dates;
  }

  monthData: any = {
    working_days: moment('"' + this.filterParams.year + "-" + this.filterParams.month, "YYYY-MM").daysInMonth(),
    total_days: moment('"' + this.filterParams.year + "-" + this.filterParams.month, "YYYY-MM").daysInMonth()
  };
  getMonthDays() {
    console.log(this.monthData);
    let queryString = "* FROM `working_days` WHERE month = '" + this.filterParams.month + "' AND year = '" + this.filterParams.year + "'";
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      if (resp.length > 0) {
        this.monthData = resp[0];
      console.log(this.monthData);
      }

    })
  }

  pageChanged(event): void {
    this.paginaton.currentPage = event.page;
    this.paginatedRecord = this.records.slice((this.paginaton.currentPage - 1) * this.paginaton.maxSize, this.paginaton.currentPage * this.paginaton.maxSize);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  selectedData: any = {};
  // updateComplainForm: any = {};
  methodFromParent(userData) {
    this.selectedData = userData;
    if(userData.action === 'image') {
      this.attachmentModal.show();
    }

  }

  selectedColumnId = '';
  onCellClicked(params) {
    console.log(params)
    this.selectedColumnId = params.column.colId;

    this.selectedData = params.data;
    if(this.selectedColumnId === 'in_attachment' || this.selectedColumnId === 'out_attachment') {
      this.attachmentModal.show();
    }
  }

  onBtnExport() {
    // var params = this.getParams();
    // if (params.suppressQuotes || params.columnSeparator) {
    //   alert(
    //     'NOTE: you are downloading a file with non-standard quotes or separators - it may not render correctly in Excel.'
    //   );
    // }
    // this.gridApi.exportDataAsCsv(params);
    // setTimeout(() => {
    //   this.exportingCsv = false;
    // }, 2000)
  }




  userList: any = [];
  projectList: any = [];
  userObj = {};
  projectObject: any = {};
  getResources() {
    let getUser = this.apiService.getData('employees');
    let getProject = this.apiService.getData('project');
    let that = this;
    Promise.all([getUser, getProject]).then((resp) => {
      that.userList = resp[0];
      that.projectUsers = resp[0];
      that.projectList = resp[1];

      _.each(that.userList, (p) => {
        that.userObj[p.phone_no] = p;
      })

      _.each(that.projectList, (p) => {
        that.projectObject[p.srl_no] = p;
      })
    })
  }

  punch_slot: any = [];
  projectUsers: any = [];
  selectProject(project) {
    console.log(project);
    let projectMatch = _.filter(this.projectList, {'name': project});
    console.log(projectMatch);
    if(projectMatch.length > 0 &&  projectMatch[0].name) {
      this.projectUsers = _.filter(this.userList, (user: any) => {
        return user.project === projectMatch[0].srl_no;
      })
      console.log(this.projectUsers);
    }

  }


  exportPdf() {
    this.exportAsService.save(this.exportAsConfig, 'Complain_Report').subscribe(() => {

    });
  }

  onItemSelect(e) {
  }
  onItemDeSelect(e) {
  }
  onSelectAll(e){

  }

  excelExportData: any = [];

  ClickExport(): void {
    let complainDate = "";
      complainDate = `Monthly Attendance Register [ ${this.filterParams.month} - ${this.filterParams.year}]`;
    let fileData = {
      fileName: `Monthly_Attendance_Register_${this.filterParams.month}_${this.filterParams.year}`,
      reportDate: moment().format('YYYY-MM-DD'),
      dateFilter: complainDate,
    }

    let header = [ 'Date','Project Name','Employee Id','Phone No', 'Full Name', 'Work Location', 'In Time','In GPS Location', 'In Location', 'View on map', 'In Image Link', 'In Image',  'Out TIme','Out GPS Location', 'Out Location', 'View On Map', 'Out Image Link', 'Out Image',  'Status'];
    this.excelService.generateExcel(this.excelExportData, fileData, header);
  }

  arrangeDataForExport(records) {
    let data: any = [];
    _.each(records, (r)=> {
          let inLatLong = `${r.in_latitude},${r.in_longitude}`;
          let outLatLong = `${r.out_latitude},${r.out_latitude}`;
          let inMapLink = `https://www.google.com/maps/search/?api=1&query=${inLatLong}`;
          let outMapLink = `https://www.google.com/maps/search/?api=1&query=${outLatLong}`;
          data.push([r.date,r.project_name,r.employee_id, r.username, r.fullName, r.location,  r.in_time, inLatLong, r.in_address, inMapLink, r.in_attachment, '=IMAGE()', r.out_time, outLatLong, r.out_location, outMapLink, r.out_attachment, '=IMAGE()', r.status]);
        });
    this.excelExportData = data;
  }

}
